import api from '../../../services/Api';
import { IAuditoriaAdiantamentoResultado } from '../interfaces/IAuditoriaAdiantamento';

export const AuditoriaAdiantamentoService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAdiantamentoResultado> {
    const response = await api.get<IAuditoriaAdiantamentoResultado>('auditoria-adiantamento/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoEstagnacao: '',
        adiantamentosEstagnados: [],
        adiantamentosConciliados: [],
      }
    );
  },
};
